import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import qs from 'query-string';

import getEnvConfig from '../../../../../utils/config/env';
import { BroadcastProps } from './broadcasts.interface';

export const broadcastsApi = createApi({
    reducerPath: 'broadcasts',
    baseQuery: fetchBaseQuery({
        baseUrl: getEnvConfig().env.API_URL,
        prepareHeaders: headers => {
            const token = localStorage.getItem('accessToken');
            headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ['Broadcasts'],

    endpoints: builder => ({
        readBroadcasts: builder.query({
            query: ({ filters, id }) => {
                const queryArgs = qs.stringify(filters, {
                    arrayFormat: 'bracket',
                    skipEmptyString: true,
                    skipNull: true,
                });
                return {
                    url: `/shops/${id}/broadcasts?${queryArgs}`,
                };
            },
            transformResponse: (response: { data: BroadcastProps[] }, meta) => {
                return {
                    items: response.data || [],
                    total:
                        Number(meta.response.headers.get('Items-Count')) || 0,
                };
            },
            providesTags: ['Broadcasts'],
        }),
        readBroadcast: builder.query({
            query: ({ id, broadcast_id }) => {
                return {
                    url: `/shops/${id}/broadcasts/${broadcast_id}`,
                    method: 'GET',
                };
            },
            transformResponse: (res: { data: BroadcastProps }) => {
                return res.data;
            },
            providesTags: ['Broadcasts'],
        }),

        createSendToListBroadcast: builder.mutation({
            query: ({ shop_id, body }) => ({
                url: `/shops/${shop_id}/broadcasts/send-to-list`,
                body: body,
                method: 'POST',
            }),
            invalidatesTags: ['Broadcasts'],
        }),
        createSendToVisitorsBroadcast: builder.mutation({
            query: ({ shop_id, body }) => ({
                url: `/shops/${shop_id}/broadcasts/send-to-visitors`,
                body: body,
                method: 'POST',
            }),
            invalidatesTags: ['Broadcasts'],
        }),
        updateBroadcast: builder.mutation({
            query: ({ shop_id, broadcast_id, body }) => ({
                url: `/shops/${shop_id}/broadcasts/${broadcast_id}`,
                body: body,
                method: 'POST',
            }),
            invalidatesTags: ['Broadcasts'],
        }),
        deleteBroadcast: builder.mutation({
            query: ({ shop_id, broadcast_id }) => {
                return {
                    url: `/shops/${shop_id}/broadcasts/${broadcast_id}`,
                    method: 'DELETE',
                    body: { shop_id: shop_id, id: broadcast_id },
                };
            },
            invalidatesTags: ['Broadcasts'],
        }),
    }),
});

export const {
    useLazyReadBroadcastsQuery,
    useLazyReadBroadcastQuery,
    useDeleteBroadcastMutation,
    useCreateSendToListBroadcastMutation,
    useCreateSendToVisitorsBroadcastMutation,
    useUpdateBroadcastMutation,
} = broadcastsApi;
